export type MetricsRange = 'latest' | '7d' | '14d' | '30d' | '90d' | 'all';

export type MetricsScope = 'suite' | 'test' | 'pipeline' | 'executionRun';

export type ExecutionStatusKey = 'passed' | 'failed' | 'skipped' | 'errored' | 'untested';

export const metricsStatusOrder: ExecutionStatusKey[] = [
  'passed',
  'failed',
  'skipped',
  'errored',
  'untested',
];

export type MetricsTrendPoint = {
  label: string;
  value: number | null;
};

export type MetricsStatusMetric = {
  key: ExecutionStatusKey;
  label: string;
  count: number;
  percentage: number;
};

export type MetricsStatusSummarySlice = {
  key: ExecutionStatusKey;
  label: string;
  value: number;
};

export type MetricsApiSeries = {
  executionTrendMetrics: MetricsTrendPoint[];
  executionDurationAverage: MetricsTrendPoint[];
  mttfSeconds: MetricsTrendPoint[];
  flakeScoreTrend: MetricsTrendPoint[];
  greenTimeSeconds: MetricsTrendPoint[];
  filteredPassRate: MetricsTrendPoint[];
  filteredFailureRate: MetricsTrendPoint[];
  filteredErrorRate: MetricsTrendPoint[];
  filteredSkipRate: MetricsTrendPoint[];
};

export type MetricsApiAverages = {
  frequencyPerDay: number;
  flakeScore: number | null;
  greenTimeSeconds: number | null;
  mttfSeconds: number | null;
  avgDurationSeconds: number | null;
};

export type MetricsApiDto = {
  metricsRangeLabel: string;
  metricsRangeDates: string[];
  isStatusFiltering: boolean;
  statusMetrics: MetricsStatusMetric[];
  statusTopRow: MetricsStatusMetric[];
  statusBottomRow: MetricsStatusMetric[];
  statusSummary: MetricsStatusSummarySlice[];
  series: MetricsApiSeries;
  averages: MetricsApiAverages;
};
